import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { DatePicker } from "antd";
import moment, { Moment } from "moment";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import { useFormContext } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import {
    AtualizacaoDeCustoEncarregadoController,
    CadastroDeCustoEncarregadoController,
    getCustoEncarregadoController,
} from "../../../../Controllers/AssistenciaTecnica/CustoEncarregadoRelatorioBI/CustoEncarregadoRelatorioBIController";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { ICustoEncarregado } from "../../../../Interfaces/AssistenciaTecnica/CustoEncarregadoRelatorioBI/CustoEncarregadoRelatorioBIInterface";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";

interface ICreateUpdateCustoEncarregado {
    row?: ICustoEncarregado;
    setShow: Dispatch<SetStateAction<boolean>>;
    ListagemDeCustoEncarregado: (
        ...args: any[]
    ) => Promise<ICustoEncarregado[]>;
}

export default function CreateUpdtateCustoEncarregado(
    props: ICreateUpdateCustoEncarregado
) {
    const formMethods = useFormContext<ICustoEncarregado>();

    const {
        execute: CadastroDeCustoEncarregado,
        loading: CadastroDeCustoEncarregadoLoading,
    } = useAsyncCallback(CadastroDeCustoEncarregadoController);

    const {
        execute: AtualizacaoDeCustoEncarregado,
        loading: AtualizacaoDeCustoEncarregadoLoading,
    } = useAsyncCallback(AtualizacaoDeCustoEncarregadoController);

    const { value: getCustoEncarregado, loading: getCustoEncarregadoLoading } =
        useAsyncEffect(async () => {
            if (props.row) {
                const res = await getCustoEncarregadoController(props.row.ID);
                return res;
            }
        }, [props.row]);

    function geradorMascaraFinanceira(inputName: keyof ICustoEncarregado) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }

    const [ano, setAno] = useState<string>(
        String(getCustoEncarregado?.ANO ?? "")
    );

    function onChange(date: Moment | null, dateString: string) {
        setAno(dateString);
    }

    const [mes, setMes] = useState<string>(
        String(getCustoEncarregado?.MES ?? "")
    );

    function onChangeMes(date: Moment | null, dateString: string) {
        setMes(dateString);
    }

    function handleCreateUpdatePrevisto(formData: ICustoEncarregado) {
        if (props.row) {
            AtualizacaoDeCustoEncarregado([
                {
                    ...formData,
                    ID: props.row.ID,
                    MES: mes ? mes : getCustoEncarregado?.MES ?? "",
                    ANO: ano ? ano : getCustoEncarregado?.ANO ?? "",
                    VL_TOTAL_FINAL:
                        formData.VL_COMBUSTIVEL +
                        formData.VL_MANUTENCAO_DO_VEICULO +
                        formData.VL_MAO_DE_OBRA,
                },
            ]).then(() => {
                props.setShow(false);
                props.ListagemDeCustoEncarregado();
            });
        } else {
            CadastroDeCustoEncarregado({
                ...formData,
                MES: mes ? mes : getCustoEncarregado?.MES ?? "",
                ANO: ano ? ano : getCustoEncarregado?.ANO ?? "",
                VL_TOTAL_FINAL:
                    formData.VL_COMBUSTIVEL +
                    formData.VL_MANUTENCAO_DO_VEICULO +
                    formData.VL_MAO_DE_OBRA,
            }).then(() => {
                props.setShow(false);
                props.ListagemDeCustoEncarregado();
            });
        }
    }

    const isLoading =
        CadastroDeCustoEncarregadoLoading ||
        AtualizacaoDeCustoEncarregadoLoading;

    return (
        <OrSpinner loading={getCustoEncarregadoLoading} spinner="capys">
            <UnForm handleSubmit={handleCreateUpdatePrevisto}>
                <div className="row">
                    <div className="col-md-6">
                        <UnForm.LazySelect
                            label="Encarregado"
                            name="ID_ENCARREGADO"
                            controller={ListarUsuariosController}
                            getKeyValue={(u) => u.ID_USUARIO}
                            getDS={(u) => u.DS_NOME}
                            defaultValue={getCustoEncarregado?.ID_ENCARREGADO}
                            registerOptions={{
                                required: "Insira um encarregado",
                            }}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-md-6">
                        <UnForm.Input
                            label="Mão de obra"
                            name="VL_MAO_DE_OBRA"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                                required: "Insira um valor",
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_MAO_DE_OBRA"
                            )}
                            defaultValue={formatMoneyReais(
                                getCustoEncarregado?.VL_MAO_DE_OBRA ?? 0
                            )}
                        />
                    </div>

                    <div className="col-md-6">
                        <UnForm.Input
                            label="Valor combustível"
                            name="VL_COMBUSTIVEL"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                                required: "Insira um valor",
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_COMBUSTIVEL"
                            )}
                            defaultValue={formatMoneyReais(
                                getCustoEncarregado?.VL_COMBUSTIVEL ?? 0
                            )}
                        />
                    </div>

                    <div className="col-md-6">
                        <UnForm.Input
                            label="Manutenção do Veículo"
                            name="VL_MANUTENCAO_DO_VEICULO"
                            registerOptions={{
                                setValueAs: (v: string) => {
                                    return Number(
                                        MoneyReaisFieldMask.unMask(v)
                                    );
                                },
                                required: "Insira um valor",
                            }}
                            onChange={geradorMascaraFinanceira(
                                "VL_MANUTENCAO_DO_VEICULO"
                            )}
                            defaultValue={formatMoneyReais(
                                getCustoEncarregado?.VL_MANUTENCAO_DO_VEICULO ??
                                    0
                            )}
                        />
                    </div>

                    <div className="col-md-6">
                        <label>Mês</label>
                        <DatePicker
                            picker="month"
                            onChange={onChangeMes}
                            className="form-control"
                            defaultValue={
                                getCustoEncarregado?.MES
                                    ? moment(
                                          getCustoEncarregado?.MES.toString(),
                                          "MM"
                                      )
                                    : undefined
                            }
                            placeholder=""
                            format={"MM"}
                        />
                    </div>

                    <div className="col-md-6">
                        <label>Ano</label>
                        <DatePicker
                            picker="year"
                            onChange={onChange}
                            className="form-control"
                            defaultValue={
                                getCustoEncarregado?.ANO
                                    ? moment(
                                          getCustoEncarregado?.ANO.toString(),
                                          "YYYY"
                                      )
                                    : undefined
                            }
                            placeholder=""
                        />
                    </div>
                    <div className="col-md-12">
                        <UnForm.SubmitButton
                            className="w-100 mt-5"
                            type="submit"
                            color={props.row ? "primary" : "success"}
                            icon={props.row ? faEdit : faPlus}
                            wrapperClassName="w-100"
                            loading={isLoading}
                            disabled={isLoading}
                            loadingSize={"sm"}
                        >
                            {props.row ? "Editar" : "Salvar"}
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>
        </OrSpinner>
    );
}
